<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12">
          <div class="row mb-2">
            <div class="col my-auto">
              <p class="d-inline font-weight-bold">Contract with</p>
              <p class="d-inline font-weight-bold ml-1">{{customer.CustomerName}}</p>
            </div>

            <div class="col-auto my-auto">
              <i
                class="float-right pointer pr-2 fas fa-edit fas-lg"
                v-show="!disableEdit"
                v-if="!editContractMode"
                @click="!disableEdit && toggleEditContractMode(true)"
              ></i>
            </div>
          </div>
          <hr />

          <div class="row">
            <div class="col-12 col-sm-6">
              <div class="row">
                <div class="col-5 col-sm-12 col-md-4">
                  <p class="font-weight-bold">Start Date:</p>
                </div>
                <div class="col col-sm-12 col-md-8">
                  <el-date-picker
                    v-if="editContractMode"
                    v-model="activeContract.StartDate"
                    format="d MMMM yyyy"
                  />
                  <p v-else>{{activeContract.StartDate | longDate}}</p>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-6">
              <div class="row">
                <div class="col-5 col-sm-12 col-md-4">
                  <p class="font-weight-bold">End Date:</p>
                </div>
                <div class="col col-sm-12 col-md-8">
                  <el-date-picker
                    v-if="editContractMode"
                    v-model="activeContract.EndDate"
                    format="d MMMM yyyy"
                  />
                  <div v-else>
                    <p>{{activeContract.EndDate | longDate}}</p>
                    <p class="mt--20" v-if="isExpired(activeContract)">
                      (Ended
                      {{activeContract.EndDate | timefromNow}})
                    </p>
                    <p class="mt--20" v-else>
                      (Ends
                      {{activeContract.EndDate | timefromNow }})
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6">
              <div class="row">
                <div class="col-5 col-sm-12 col-md-4">
                  <p class="font-weight-bold">Notice Period:</p>
                </div>
                <div v-if="editContractMode" class="col col-sm-12 col-md-8">
                  <input
                    type="number"
                    class="w-50 text-center border brs pb-1 pt-1"
                    v-model="activeContract.NoticePeriodDays"
                  />
                  <p class="d-inline pb-1 pt-1">days</p>
                </div>
                <div v-else class="col col-sm-12 col-md-8">
                  <p>{{activeContract.NoticePeriodDays + ' days'}}</p>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-6">
              <div class="row">
                <div class="col-5 col-sm-12 col-md-4">
                  <p class="font-weight-bold">Notice Due:</p>
                </div>
                <div class="col col-sm-12 col-md-8">
                  <p
                    :class="{'border brs pb-1 pt-1 pl-2' : editContractMode}"
                  >{{activeContract.EndDate | moment('subtract', activeContract.NoticePeriodDays.toString() + ' days') | longDate}}</p>
                </div>
              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-12 col-sm-6">
              <div class="row">
                <div class="col-5 col-sm-12 col-md-4">
                  <p class="font-weight-bold">Contract Type:</p>
                </div>
                <div class="col col-sm-12 col-md-8">
                  <b-form-select
                    v-if="editContractMode"
                    v-model="activeContract.ContractType"
                    class="form-control"
                    required
                  >
                    <option value="Agreed">Agreed</option>
                    <option value="Deemed">Deemed</option>
                  </b-form-select>
                  <p v-else>{{activeContract.ContractType}}</p>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="row">
                <div class="col-5 col-sm-12 col-md-4">
                  <p class="font-weight-bold">Contract Status:</p>
                </div>
                <div class="col col-sm-12 col-md-8">
                  <p :class="{'border brs pb-1 pt-1 pl-2' : editContractMode}">{{activeContract.ContractStatus.match(/[A-Z][a-z]+|[0-9]+/g).join(" ")}}</p>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6" v-if="activeContract.ContractType != 'Deemed'">
              <div class="row">
                <div class="col-5 col-sm-12 col-md-4">
                  <p class="font-weight-bold">Signed Date:</p>
                </div>
                <div class="col col-sm-12 col-md-8">
                  <el-date-picker
                    v-if="editContractMode"
                    v-model="activeContract.SignedDate"
                    format="d MMMM yyyy"
                  />
                  <p v-else>{{activeContract.SignedDate | longDate}}</p>
                </div>
              </div>
            </div>
            <div class="row" v-if="hasActiveService">
              <div class="col-12">
                <button
                  v-if="!editContractMode"
                  role="button"
                  class="btn btn-hc m-20"
                  @click="$bvModal.show('renewContract')"
                  :disabled="activeContract.ContractStatus != 'Chargeable' || !isLastServiceContract"
                >Renew Contract</button>
              </div>
            </div>
          </div>
          <div v-if="editContractMode">
            <div class="row justify-content-end">
              <!-- <div class="col-12">
              <div class="text-left float-right pb-4">-->
              <b-btn
                @click="toggleEditContractMode(false)"
                class="col-auto btn btn-hc mr-2 mb-3 mt-1"
                :disabled="submitStatusContract === 'PENDING'"
              >Cancel</b-btn>
              <b-btn
                @click="saveChanges()"
                class="col col-sm-auto btn btn-hc mb-3 mt-1"
                :disabled="submitStatusContract === 'PENDING'"
              >Save Changes</b-btn>
              <!-- </div>
              </div>-->
            </div>
          </div>
          <hr />
          <div class="row mb-2">
            <img
              src="@/assets/img/tariff.png"
              class="col-auto px-2 service-bundle__icon"
              alt="Tariff icon"
            />
            <p class="col col-sm d-inline font-weight-bold">Service Bundles</p>
            <div class="col-auto col-sm d-inline my-auto">
              <a
                class="btn btn-hc-nb float-right"
                role="button"
                v-show="!disableEdit"
                @click="!disableEdit && $bvModal.show('addServiceBundle')"
              >
                <img src="@/assets/img/add_icon_hcg.png" class="d-inline-block" alt="Add Icon" />
              </a>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="bg-secondaryL p-2 W-100">
                <div class="table-responsive-lg">
                  <b-table
                    id="ThisIdOverwritesTheRandomlyGeneratedOneSoThatSnapshotTestsDoNotFailEveryTime_8"
                    responsive
                    striped
                    fixed
                    hover
                    :items="orderByEffectiveFrom(activeContract.ServiceBundles)"
                    :fields="serviceBundleFields"
                    @row-clicked="selectServiceBundle"
                  >
                    <template
                      slot="ServiceBundleName"
                      slot-scope="data"
                    >{{data.item.ServiceBundleName}}</template>
                    <template
                      slot="ServiceBundleDescription"
                      slot-scope="data"
                    >{{data.item.ServiceBundleDescription}}</template>
                    <template
                      slot="EffectiveFrom"
                      slot-scope="data"
                    >{{data.item.EffectiveFrom | longDate}}</template>
                    <template slot="EffectiveTo" slot-scope="data">
                      <div
                        v-if="data.item.hasOwnProperty('EffectiveTo')"
                      >{{data.item.EffectiveTo | moment('DD MMMM YYYY')}}</div>
                      <div v-else>Present</div>
                    </template>
                    <template slot="Actions" slot-scope="row">
                      <div class="d-flex w-100 justify-content-center align-self-center">
                        <i
                          v-show="!disableEdit"
                          v-if="currentBundle(row) && activeContract.ServiceBundles.length > 1"
                          class="float-right pointer fas fa-trash mt-2 mx-2"
                          @mouseover="isSelectable=false"
                          @mouseleave="isSelectable=true"
                          @click="toggleDeleteBundle(row)"
                        ></i>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
          <!-- Gas Table Start -->
          <div class="row my-2 py-2" v-if="gasServices.length > 0">
            <div class="col-sm-6 my-auto">
              <img src="@/assets/img/gas_icon.png" class="px-2" alt="Gas Icon" />
              <p class="d-inline font-weight-bold">Gas Services</p>
            </div>
          </div>

          <div class="row" v-if="gasServices.length > 0">
            <div class="col-sm-12">
              <div class="bg-secondaryL p-2 W-100">
                <div class="table-responsive-lg">
                  <b-table
                    id="ThisIdOverwritesTheRandomlyGeneratedOneSoThatSnapshotTestsDoNotFailEveryTime_7"
                    fixed
                    responsive
                    striped
                    :items="orderByEffectiveFrom(gasServices)"
                    :fields="servicesFields"
                    hover
                    @row-clicked="selectService"
                  >
                    <template v-slot:cell(ServiceIdentifier)="data">{{data.item.ServiceIdentifier}}</template>
                    <template
                      slot="EffectiveFrom"
                      slot-scope="data"
                    >{{getServiceTenancy(data.item.GasDetails.TenancySharedId).EffectiveFrom | moment('DD MMMM YYYY')}}</template>
                    <template slot="EffectiveTo" slot-scope="data">
                      <div v-if="getServiceTenancy(data.item.GasDetails.TenancySharedId).EffectiveTo"
                      >{{getServiceTenancy(data.item.GasDetails.TenancySharedId).EffectiveTo  | moment('DD MMMM YYYY')}}</div>
                    <div v-else>Present</div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
          <!-- Gas Table End -->
          <!-- Elec Table Start -->
          <div class="row my-2" v-if="elecServices.length > 0">
            <div class="col-sm-6 my-auto">
              <img src="@/assets/img/electricity_icon.png" class="px-2" alt="Electricity Icon" />
              <p class="d-inline font-weight-bold">Electricity Services</p>
            </div>
          </div>

          <div class="row" v-if="elecServices.length > 0">
            <div class="col-sm-12">
              <div class="bg-secondaryL p-2 W-100">
                <div class="table-responsive-lg">
                  <b-table
                    id="ThisIdOverwritesTheRandomlyGeneratedOneSoThatSnapshotTestsDoNotFailEveryTime_6"
                    fixed
                    responsive
                    striped
                    :items="orderByEffectiveFrom(elecServices)"
                    :fields="servicesFields"
                    hover
                    @row-clicked="selectService"
                  >
                    >
                    <template
                      slot="ServiceIdentifier"
                      slot-scope="data"
                    >{{data.item.ServiceIdentifier}}</template>
                    <template
                      slot="EffectiveFrom"
                      slot-scope="data"
                    >{{getServiceTenancy(data.item.ElectricityDetails.TenancySharedId).EffectiveFrom | longDate}}</template>
                    <template slot="EffectiveTo" slot-scope="data">
                      <div v-if="getServiceTenancy(data.item.ElectricityDetails.TenancySharedId).EffectiveTo"
                      >{{getServiceTenancy(data.item.ElectricityDetails.TenancySharedId).EffectiveTo | moment('DD MMMM YYYY')}}
                    </div>
                    <div v-else>Present</div>
                    </template>
                    <template slot="row-details" slot-scope="row">
                      <b-card>
                        <b-row class="mb-2"></b-row>

                        <b-row class="mb-2"></b-row>

                        <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>
                      </b-card>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
          <!-- Priority Services -->
          <hr />
          <div class="row my-2 pt-2">
            <i class="col-auto col-sm-auto fas fa-exclamation-triangle fas-xl" />
            <p class="col col-sm d-inline font-weight-bold">Priority Services</p>
            <div class="col-3 col-sm d-inline my-auto">
              <a class="btn btn-hc-nb float-right" role="button">
                <img
                  v-if="!disableEdit"
                  src="@/assets/img/add_icon_hcg.png"
                  class="d-inline-block"
                  alt="Add Icon"
                  @click="$bvModal.show('addPriorityServiceSet')"
                />
              </a>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="bg-secondaryL p-2 W-100" v-if="priorityServiceSets.length > 0">
                <div class="table-responsive-lg">
                  <b-table
                    id="ThisIdOverwritesTheRandomlyGeneratedOneSoThatSnapshotTestsDoNotFailEveryTime_3"
                    striped
                    fixed
                    hover
                    @row-clicked="selectPSRSet"
                    :items="priorityServiceSets"
                    :fields="{Type:{label:'Type'}, Password:{label:'Password'}, Notes: {label:'Notes'}}"
                  >
                    <template slot="Type" slot-scope="data">{{data.item.Name}}</template>
                    <template slot="Password" slot-scope="data">{{data.item.Password}}</template>
                  </b-table>
                </div>
              </div>
              <div v-else>
                <p>There are currently no priority service sets</p>
              </div>
            </div>
          </div>
          <!-- Priority Services -->
        </div>
      </div>
    </div>

    <b-modal id="deleteBundle">
      <template slot="modal-header" slot-scope="{ close }">
        <div class="container-fluid">
          <div class="row">
            <div class="col-9 my-auto">
              <h5 class="modal-title">Delete Service Bundle</h5>
            </div>
            <div class="col-3 my-auto">
              <div>
                <div>
                  <span>
                    <a class="close">
                      <i
                        class="far fa-times-circle fa-2x"
                        @click="close()"
                        id="closeDeleteServiceBundle"
                        aria-label="Close"
                      ></i>
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template slot="default">
        <p class="my-4 text-center">Are you sure you want to delete this service bundle tenure?</p>
      </template>

      <template slot="modal-footer" slot-scope="{ close }">
        <button
          type="submit"
          class="btn btn-hc float-right"
          @click="deleteServiceBundle"
          :disabled="submitStatusBundle == 'PENDING'"
        >Yes</button>
        <button
          type="submit"
          class="btn btn-hc float-right"
          @click="close()"
          :disabled="submitStatusBundle == 'PENDING'"
        >No</button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { _ } from 'underscore';

// Mixins
import contractsMixin from '@/mixins/contracts/contracts';
import _filters from '@/mixins/filters';

export default {
  name: 'contract',
  mixins: [contractsMixin, _filters],
  data() {
    return {
      isSelectable: true,
      submitStatusContract: null,
      submitStatusBundle: null,
      submitStatusServices: null,
      editContractMode: false,
      editServiceMode: false,
      // editbundleMode: false,
      searchQuery: null,
      serviceBundleFields: {
        ServiceBundleName: {
          label: 'Name',
        },
        ServiceBundleDescription: {
          label: 'Description',
        },
        EffectiveFrom: {
          label: 'Effective From',
          sortable: true,
        },
        EffectiveTo: {
          label: 'Effective To',
          sortable: true,
        },
        Actions: {
          label: '',
        },
      },
      searchResultFields: {
        name: {
          key: 'Document.ServiceBundleName',
          label: 'Service Bundle',
          class: 'text-center',
        },
        description: {
          key: 'Document.ServiceBundleDescription',
          label: 'Description',
          class: 'text-center',
        },
      },
      selectedBundleFields: {
        name: {
          key: 'ServiceBundleName',
          label: 'Service Bundle',
          class: 'text-center',
        },
        description: {
          key: 'ServiceBundleDescription',
          label: 'Description',
          class: 'text-center',
        },
        action: {
          label: '',
          class: 'text-center',
        },
      },
      servicesFields: {
        ServiceIdentifier: {
          label: 'Identifier',
        },
        EffectiveFrom: {
          label: 'Effective From',
          sortable: true,
        },
        EffectiveTo: {
          label: 'Effective To',
          sortable: true,
        },
        Actions: {
          label: '',
        },
      },
    };
  },
  computed: {
    customer() {
      return this.$store.state.customers.customer;
    },
    gasServices() {
      return this.activeContract.Services.filter(
        (service) => service.ServiceType == 'Gas'
      );
    },
    elecServices() {
      return this.activeContract.Services.filter(
        (service) => service.ServiceType == 'Electricity'
      );
    },
    priorityServiceSets() {
      return this.$store.state.contracts.customerLevelPriorityServices;
    },
    hasActiveService() {
      var activeServices = [];
      this.activeContract.Services.forEach((service) => {
        if (
          !service.hasOwnProperty('EffectiveTo') ||
          moment().isSameOrBefore(service.EffectiveTo)
        ) {
          activeServices.push(service);
        }
      });
      return activeServices.length > 0;
    },
    disableEdit() {
      return this.activeContract.ContractStatus == 'NotChargeable';
    },
    isLastServiceContract() {
      if (!this.contracts) return;

      const services = this.activeContract.Services.map(s => s.ServiceIdentifier)

      return this.contracts
        .filter(c => c.ContractStatus == 'Chargeable')
        .filter(c => c.Services.some(s => services.includes(s.ServiceIdentifier)))
        .sort((a, b) => a.StartDate < b.StartDate ? 1 : -1 )
        .at(0).Id === this.activeContract.Id;
    },
  },
  methods: {
    isExpired(contract) {
      return moment().isSameOrAfter(moment(contract.EndDate).add(1, 'days'));
    },
    currentBundle(row) {
      return (
        _.sortBy(
          this.activeContract.ServiceBundles,
          'EffectiveFrom'
        ).reverse()[0].EffectiveFrom == row.item.EffectiveFrom
      );
    },
    getServiceTenancy(tenancySharedId) {
      return _.findWhere(this.tenancies, { TenancySharedId: tenancySharedId });
    },
    clearSelection(row) {
      row.ServiceBundleName = null;
      row.ServiceBundleDescription = null;
      row.ServiceBundleId = null;
    },
    toggleEditContractMode(bool) {
      if (bool) {
        this.beforeEditingContract = Object.assign({}, this.activeContract);
      }
      if (!bool) {
        Object.assign(this.activeContract, this.beforeEditingContract);
      }
      this.editContractMode = bool;
    },
    toggleDeleteBundle(bundleRow) {
      this.$bvModal.show('deleteBundle');
      this.$store.commit('updateActiveBundle', bundleRow.item);
    },
    orderByEffectiveFrom(collection) {
      return this.$_.sortBy(collection, function(item) {
        return item.EffectiveFrom;
      }).reverse();
    },
    navigate(section, route) {
      this.activeSection = section;
      if (!route) {
        return this.$store.commit('addBreadcrumbItems', [section]);
      }
      this.$store.commit('addBreadcrumbItems', route);
    },
    selectServiceBundle(bundle) {
      if (this.isSelectable) {
        this.$store.commit('updateActiveBundle', bundle);
        this.$store.commit(
          'updateActiveService',
          this.orderByEffectiveFrom(this.activeContract.Services)[0]
        );
        this.navigate('ServiceBundle', ['ServiceBundle']);
      }
    },
    selectService(service) {
      this.$store.commit(
        'updateActiveSection',
        service.ServiceType + 'Service'
      );
      this.$store.commit('addBreadcrumbItems', [
        service.ServiceType + 'Service',
      ]);
      this.$store.commit('updateActiveService', service);
    },
    selectPSRSet(set) {
      this.$store.commit('updateActiveSection', 'PriorityServiceSet');
      this.$store.commit('addBreadcrumbItems', ['PriorityServiceSet']);
      this.$store.commit('updateActivePSRSet', set);
    },
    saveChanges() {
      this.submitStatusContract = 'PENDING';
      this.$http
        .put(
          'https://' +
            Vue.config.honeycomb.queenbee.domain +
            '/api/v1/contracts/' +
            this.activeContract.Id,
          {
            SignedDate: moment
              .utc(moment(this.activeContract.SignedDate).format('DD MMM YYYY'))
              .format(),
            StartDate: moment
              .utc(moment(this.activeContract.StartDate).format('DD MMM YYYY'))
              .format(),
            EndDate: moment
              .utc(moment(this.activeContract.EndDate).format('DD MMM YYYY'))
              .format(),
            NoticePeriodDays: parseInt(this.activeContract.NoticePeriodDays),
            ContractType: this.activeContract.ContractType,
            ContractStatus: this.activeContract.ContractStatus,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.submitStatusContract = 'OK';
          this.$snotify.success(`Success! Changes saved.`);
          this.editContractMode = false;
          this.$store.dispatch('getContracts');
          this.activeContract = response.data;
        })
        .catch((error) => {
          this.submitStatusContract = 'ERROR';
          if (error.response) {
            if (error.response.data.MoreInformation.length > 0) {
              error.response.data.MoreInformation.forEach((e) => {
                this.$snotify.error(`${e.Error}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              });
            } else {
              this.$snotify.error(`${error.response.data.UserDescription}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          } else if (error.request) {
            this.$snotify.error(`No response received.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }

          this.editContractMode = false;
          this.$store.dispatch('getContracts');
        });
    },
    saveServiceChanges(service) {
      this.submitStatusServices = 'PENDING';
      this.$http
        .put(
          'https://' +
            Vue.config.honeycomb.queenbee.domain +
            '/api/v1/contracts/' +
            this.activeContract.Id +
            '/services/' +
            service.ServiceIdentifier,
          {
            ServiceIdentifier: service.ServiceIdentifier,
            // OverridePriceEffectiveFromDate: moment.utc(moment(service.EffectiveFrom).format(
            //     'DD.MM.YYYY')).format(),
            // OverridePriceEffectiveToDate: service.hasOwnProperty('EffectiveTo') ? moment.utc(
            //     moment(service.EffectiveTo).format('DD.MM.YYYY')).format() : undefined,
            DoNotBill: service.DoNotBill,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.submitStatusServices = 'OK';
          this.$snotify.success(`Success! Changes saved.`);
          this.$store.dispatch('getContracts');
          this.editServiceMode = false;
          this.activeContract = response.data;
        })
        .catch((error) => {
          this.submitStatusServices = 'ERROR';
          Object.assign(service, this.beforeEditingService);
          if (error.response) {
            if (error.response.data.MoreInformation.length > 0) {
              error.response.data.MoreInformation.forEach((e) => {
                this.$snotify.error(`${e.Error}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              });
            } else {
              this.$snotify.error(`${error.response.data.UserDescription}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          } else if (error.request) {
            this.$snotify.error(`No response received.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },
    saveBundleChanges(bundle) {
      this.submitStatusBundle = 'PENDING';
      this.$http
        .put(
          'https://' +
            Vue.config.honeycomb.queenbee.domain +
            '/api/v1/contracts/' +
            this.activeContract.Id +
            '/serviceBundles/' +
            bundle.Id,
          {
            EffectiveFrom: moment
              .utc(moment(bundle.EffectiveFrom).format('YYYY-MM-DD'))
              .format(),
            ServiceBundleId: bundle.ServiceBundleId,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.submitStatusBundle = 'OK';
          this.$snotify.success(`Success! Changes saved.`);
          this.$store.dispatch('getContracts');
          this.activeContract = response.data;
        })
        .catch((error) => {
          this.submitStatusBundle = 'ERROR';
          Object.assign(bundle, this.beforeEditingBundle);
          if (error.response) {
            if (error.response.data.MoreInformation.length > 0) {
              error.response.data.MoreInformation.forEach((e) => {
                this.$snotify.error(`${e.Error}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              });
            } else {
              this.$snotify.error(`${error.response.data.UserDescription}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          } else if (error.request) {
            this.$snotify.error(`No response received.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },
    deleteServiceBundle() {
      this.submitStatusBundle = 'PENDING';
      this.$http
        .delete(
          'https://' +
            Vue.config.honeycomb.queenbee.domain +
            '/api/v1/contracts/' +
            this.activeContract.Id +
            '/serviceBundles/' +
            this.$store.state.contracts.activeBundle.Id,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.submitStatusBundle = 'OK';
          this.$snotify.success(`Success! Service bundle tenure deleted.`);
          this.$store.dispatch('getContracts');
          this.activeContract = response.data;
          this.$store.commit('updateActiveBundle', null);
          document.getElementById('closeDeleteServiceBundle').click();
        })
        .catch((error) => {
          this.submitStatusBundle = 'ERROR';
          if (error.response) {
            if (error.response.data.MoreInformation.length > 0) {
              error.response.data.MoreInformation.forEach((e) => {
                this.$snotify.error(`${e.Error}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              });
            } else {
              this.$snotify.error(`${error.response.data.UserDescription}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          } else if (error.request) {
            this.$snotify.error(`No response received.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },
    // search() {
    //   this.$store.dispatch("serviceBundleSearch", {
    //     Criteria: this.searchQuery
    //   });
    // },
    // selectNewServiceBundle(item) {
    //   this.$store.commit("updateServiceBundleResults", {
    //     Results: null
    //   });
    //   this.searchQuery = null;
    //   var bundle = _.findWhere(this.activeContract.ServiceBundles, {
    //     ServiceBundleId: null
    //   });
    //   bundle.ServiceBundleId = item.Document.ServiceBundleId;
    //   bundle.ServiceBundleName = item.Document.ServiceBundleName;
    //   bundle.ServiceBundleDescription = item.Document.ServiceBundleDescription;
    // },
    // toggleEditServiceMode(bool, row) {
    //   if (bool && !this.editServiceMode) {
    //     this.beforeEditingService = Object.assign({}, row.item);
    //   }
    //   row.toggleDetails();
    //   if (!bool && this.editServiceMode) {
    //     Object.assign(row.item, this.beforeEditingService);
    //   }
    //   this.editServiceMode = bool;
    // },
  },
  watch: {
    contracts(contracts) {
      if (contracts)
        this.activeContract = contracts.find(
          (c) => c.Id === this.activeContract.Id
        );
    },
  },
};
</script>

<style scoped>
.service-bundle__icon {
  width: auto;
  height: 100%;
}
</style>
